import { PermissionsType } from '@/common/permissionsConst';
import IndustrialGreenMicBigScreen from '.';
import IncomeCompare from './IncomeCompare';
import { Themes } from '@maxtropy/components';
const routes = [
  {
    path: '/industrial/greenMicrogrid/overview',
    element: <IndustrialGreenMicBigScreen />,
    permission: PermissionsType.P_MICROGRIDOVERVIEW,
    theme: Themes.DARK
  },
  {
    path: '/industrial/greenMicrogrid/overview/compare',
    element: <IncomeCompare />,
    permission: PermissionsType.P_COMPARISONSTRATEGYRETURNS,
  },
];

export default routes;
